import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import { convertToCamel } from "@lib/convertToCamel";

interface DynamicTranslation {
  id: number;
  key: string;
  value: string;
  locale: "en" | "fr";
}

// Transform the translations array into nested objects
const transformTranslations = (translations: DynamicTranslation[]) => {
  return translations.reduce(
    (acc, translation) => {
      const { key, value, locale } = translation;
      if (!acc[locale]) {
        acc[locale] = {};
      }

      // Handle nested keys (e.g., "emails.challenge_submitted.user.body_line1")
      const parts = key.split(".");
      let current = acc[locale];

      for (let i = 0; i < parts.length - 1; i++) {
        current[parts[i]] = current[parts[i]] ?? {};
        current = current[parts[i]];
      }

      current[parts[parts.length - 1]] = value;
      return acc;
    },
    { en: {}, fr: {} },
  );
};

const dynamicTranslations = transformTranslations(
  convertToCamel<DynamicTranslation[]>(VisitWidget.store.translations),
);

const resources = {
  en: {
    ...en,
    ...dynamicTranslations.en,
  },
};

i18n
  // passes i18n down to react-i18next
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

// eslint-disable-next-line import/no-default-export
export default i18n;
